

<div class="_dialog-content">
    <div class="text-center  mb-4">
        <div class="text-xl font-bold">{{'_LOYALTY.welcome' | translate}}</div>
        {{args.descCaption | translate}}
    </div>

    <div class="_actions">
        <button type="button" mat-flat-button color="accent" [mat-dialog-close]="true" class="rounded">
            <div class="text-base" style="white-space:normal; line-height: 1.2; font-weight:500">
                <div [innerHTML]="args.approveCaption | translate | safeHtml"></div>
            </div>
        </button>

        <button type="button" mat-stroked-button color="primary" [mat-dialog-close]="false" class="rounded">
            {{args.cancelCaption | translate}}
        </button>
    </div>

    <div class="text-xs text-center">
        <div>{{args.licenseCaption | translate}}</div>
        <div class="flex a-center j-center">
            <a class="inline link mr-2" (click)="appService.showContractDialog('contract')">{{'READ_AND_APPROVE_CONTRACT_C' | translate}}</a>
            <a class="inline link" (click)="appService.showContractDialog('privacy')">{{'READ_AND_APPROVE_CONTRACT_D' | translate}}</a>
        </div>
    </div>

</div>






